<template>
  <div>
    <h3 class="h3 mt0">Become a Reviewer</h3>

    <p v-if="applied" class="p">Your current application to become a Reviewer is still pending, we will contact you via email with the results</p>

    <p v-if="!dataComplete" class="p">You must complete all sections in <router-link class="fw-bold c-secondary" :to="{ name: 'dashboard-profile-info' }">My Information</router-link> and add at least one location to <router-link class="fw-bold c-secondary" :to="{ name: 'dashboard-dentist-locations'}">My Locations</router-link> before you can apply to become a Reviewer</p>

    <div v-show="!applied && dataComplete">
      <p class="p">Join the movement! Do you want to help highlight good dental care and identify bad work?</p>
      <p class="p">We’re looking for good dentists and specialist to join our pool of expert reviewers. The reviewing process is fast, simple and anonymous. You can log on to our secure site when you have time and quickly review a set of radiographs right on your mobile phone.</p>
      <p class="p">The criteria for reviewing root canals isn’t our opinion, <a href="https://www.aae.org/specialty/wp-content/uploads/sites/2/2018/04/TreatmentStandards_Whitepaper.pdf" target="_blank">it’s the official position of the AAE and ADA.</a> We want to provide patients and dentists with clear criteria on quality dental care.</p>
      <p class="p">Join the fight for transparency in the dental industry!</p>
      <p class="p">Please make sure that all information listed in your dentist profile is accurate. To verify your identity, please upload the following information:</p>
      <module-form
        class="reviewer-form"

        button="primary"
        form-id="reviewer-form"
        :fields="fields"

        submit="Register as Reviewer"
        :action="action"
        :success="success"
        :fail="fail"
      />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Services
import { arrayLoop } from 'services/array';

// Modules
import ModuleForm from 'modules/Form';

// Export
export default {
  name: `ui-dashboard-reviewer-application`,

  // Components
  components: {
    ModuleForm,
  },

  // Data
  computed: {
    ...mapGetters(`forms`, [
      `getModel`,
    ]),
    ...mapGetters(`auth`, [
      `user`,
    ]),
    model() {
      return this.getModel(`reviewer-form`);
    },
    applied() {
      return this.user.profile.has_applied_for_reviewer_privileges;
    },
    dataComplete() {
      let finished = true;

      const basicInfo = [
        `first_name`,
        `last_name`,
      ];
      const profileInfo = [
        `license_number`,
        `phone_number`,
        `specialty`,
      ];

      arrayLoop(basicInfo, (i, key) => {
        if (this.user[key].length <= 0) return finished = false;
      });

      arrayLoop(profileInfo, (i, key) => {
        if (this.user.profile[key] && this.user.profile[key].length <= 0) return finished = false;
      });

      if (this.user.locationsCount === 0) return finished = false;

      return finished;
    },
    fields() {
      const createFile = (label, required = false) => ({
        label,
        type: `file`,
        labelHidden: true,
        button: `primary`,
        validations: {
          required,
        },
      });

      const fields = {
        identity_card: {
          heading: {
            heading: `Driver's License`,
            level: `h5`,
          },
          intro: {
            copy: `Upload a driving license or any other documents that proves your identity:`,
          },
          ...createFile(`Identity Card`, true),
        },

        dental_license: {
          heading: {
            heading: `Dental License`,
            level: `h5`,
          },
          intro: {
            copy: `Upload a dental license:`,
          },
          ...createFile(`Dental License`, true),
        },

        specialty_certificate: {
          heading: {
            heading: `Specialty Certificate`,
            level: `h5`,
          },
          intro: {
            copy: `Upload a copy of your specialty certificate:`,
          },
          ...createFile(`Specialty Certificate`, false),
        },
        terms: {
          type: `boolean`,
          validations: {
            required: true,
          },
        },
      };
      return fields;
    },
  },

  // Methods
  methods: {
    ...mapActions(`reviewer`, [
      `requestBecomeReviewer`,
    ]),
    action() {
      return this.requestBecomeReviewer(this.model);
    },
    success(/*success*/) {
      setTimeout(() => {
        this.$router.push({
          name: `success`,
          params: {
            page: `reviewer-application`,
          },
        });
      }, 1000);
    },
    fail(fail) {
      console.warn(`Fail`, fail);
    },
  },

};
</script>



// WEBPACK FOOTER //
// ReviewerApplication.vue?4ab95ee4